// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.epr-selector-roster {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.epr-selector-roster h5 {
  color: #0A4064;
  margin-bottom: 0px;
}
.epr-selector-roster .epr-select-dropdown {
  margin-left: 1rem;
  padding: 0.3rem 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  border: 2px solid #0A4064;
  border-radius: 8px;
  background-color: white;
  color: #0A4064;
  cursor: pointer;
}
.epr-selector-roster .epr-select-dropdown:hover {
  background-color: #EDf0F1;
}

.inline-select-label {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 0px;
}
.inline-select-label .epr-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 3px;
}

.no-margin-btn-roster {
  margin-left: -10px;
}

.epr-toggle-container {
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  margin-bottom: 32px;
}

.share-mode-roster {
  margin-bottom: 2rem;
}
.share-mode-roster h5 {
  color: #0A4064;
}
.share-mode-roster .share-mode-options-roster {
  display: flex;
  gap: 1rem;
}
.share-mode-roster .share-mode-options-roster > * {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.share-mode-roster .share-mode-options-roster .mode-button {
  background-color: white;
  color: #0A4064;
  border: 2px solid #0A4064;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: center;
}
.share-mode-roster .share-mode-options-roster .mode-button.active {
  background-color: #0A4064;
  color: white;
}
.share-mode-roster .share-mode-options-roster .mode-button:hover {
  background-color: #0A4064;
  color: white;
  opacity: 0.9;
}
.share-mode-roster .share-mode-options-roster .mode-button:disabled {
  background-color: #D1D3D4;
  border-color: #A7A9AC;
  color: #808080;
  cursor: not-allowed;
}
.share-mode-roster .share-mode-options-roster .mode-help-text {
  font-size: 0.85rem;
  color: #808080;
  margin-top: 0.5rem;
  text-align: center;
}

.current-roster {
  align-items: center;
  display: flex;
  margin-bottom: 0.75rem;
}
.current-roster h5 {
  color: #0A4064;
  margin-bottom: 0px;
  margin-right: 32px;
}
.current-roster h5 span {
  color: #0669B3;
  font-weight: 700;
}

.no-margin {
  margin-bottom: 0px;
}

.bottom-margin {
  margin-bottom: 1rem;
}

.roster-select-section {
  background-color: white;
  border-radius: 5px;
  margin-top: 1rem;
  padding: 1.25rem;
}
.roster-select-section .select-label-ic {
  gap: 8px;
  margin-bottom: 16px;
}
.roster-select-section .select-label-ic .ic-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 3px;
  margin-top: 12px;
  min-width: 230px;
}

.delta-section {
  margin-bottom: 1rem;
}
.delta-section .delta-border {
  border: 2px solid #FEBF31;
}
.delta-section .delta-text {
  margin-bottom: 24px;
}

.epr-roster-manage-section {
  border-radius: 10px;
}
.epr-roster-manage-section .bold-number {
  font-weight: 700;
  margin-left: 4px;
}

.accordion-button {
  background-color: white !important;
}

.accordion-button:focus {
  box-shadow: none;
  border: 3px solid #1786DB !important;
}

.delta-button-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 6px;
  width: 100%;
}
.delta-button-container .select-all-check-btn {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background-color: white;
  border: 1px solid #0669B3;
  color: #0669B3;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 150px;
  padding: 4px 8px;
}
.delta-button-container .select-all-check-btn input {
  margin-right: 12px;
  transform: scale(1.2);
}
.delta-button-container .select-all-check-btn:hover {
  transform: scale(1.035);
}

.delta-student-grid {
  border-radius: 3px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px;
}
.delta-student-grid .delta-student-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
}

/* Responsive Grid */
@media (max-width: 839px) {
  .delta-student-grid {
    grid-template-columns: 1fr;
  }
}
@media (min-width: 840px) and (max-width: 1499px) {
  .delta-student-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1500px) {
  .delta-student-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ManageRoster.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AASF;AAPE;EACE,cDDM;ECEN,kBAAA;AASJ;AANE;EACE,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cDbM;ECcN,eAAA;AAQJ;AANI;EACE,yBDDE;ACSR;;AAFA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;AAKF;AAHE;ECnCE,kBDoCsB;EACtB,yBAAA;EACA,cDVK;ECWL,YAAA;AAKJ;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAIF;;AADA;EACE,mBAAA;AAIF;AAFE;EACE,cDpDM;ACwDV;AADE;EACE,aAAA;EACA,SAAA;AAGJ;AAAI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAEN;AACI;EACE,uBAAA;EACA,cDrEI;ECsEJ,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AACN;AACM;EACE,yBD/EE;ECgFF,YAAA;AACR;AAEM;EACE,yBDpFE;ECqFF,YAAA;EACA,YAAA;AAAR;AAGM;EACE,yBDzEA;EC0EA,qBDzEA;EC0EA,cDzEA;EC0EA,mBAAA;AADR;AAKI;EACE,kBAAA;EACA,cDhFE;ECiFF,kBAAA;EACA,kBAAA;AAHN;;AAQA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AALF;AAOE;EACE,cDhHM;ECiHN,kBAAA;EACA,kBAAA;AALJ;AAOI;EACE,cD9FO;EC+FP,gBAAA;AALN;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAPF;AASE;EACE,QAAA;EACA,mBAAA;AAPJ;AASI;ECnJA,kBDoJwB;EACtB,yBAAA;EACA,cD1HG;EC2HH,YAAA;EACA,gBAAA;EACA,gBAAA;AAPN;;AAYA;EACE,mBAAA;AATF;AAWE;EACE,yBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;;AAcA;EACE,mBAAA;AAXF;AAaE;EACE,gBAAA;EACA,gBAAA;AAXJ;;AAeA;EACE,kCAAA;AAZF;;AAeA;EACE,gBAAA;EACA,oCAAA;AAZF;;AAeA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAZF;AAcE;EClME,kBDmMsB;EC9KtB,2CAAA;EDgLA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cD3KS;EC4KT,eAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAZJ;AAcI;EACE,kBAAA;EACA,qBAAA;AAZN;AAeI;EACE,uBAAA;AAbN;;AAkBA;EACE,kBAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;AAfF;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0CAAA;AAfJ;;AAqBA,oBAAA;AACA;EACE;IACE,0BAAA;EAlBF;AACF;AAqBA;EACE;IACE,qCAAA;EAnBF;AACF;AAsBA;EACE;IACE,qCAAA;EApBF;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.epr-selector-roster {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n\n  h5 {\n    color: $dk-blue;\n    margin-bottom: 0px;\n  }\n\n  .epr-select-dropdown {\n    margin-left: 1rem;\n    padding: 0.3rem 0.5rem;\n    font-size: 1rem;\n    font-weight: 500;\n    border: 2px solid $dk-blue;\n    border-radius: 8px;\n    background-color: white;\n    color: $dk-blue;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $grey0;\n    }\n  }\n\n}\n\n.inline-select-label {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 0px;\n\n  .epr-select {\n    @include borderRadius(5px);\n    border: 1px solid $grey3;\n    color: $grey4a;\n    padding: 3px;\n  }\n}\n\n.no-margin-btn-roster {\n  margin-left: -10px;\n}\n\n.epr-toggle-container {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-start;\n  margin-bottom: 32px;\n}\n\n.share-mode-roster {\n  margin-bottom: 2rem;\n\n  h5 {\n    color: $dk-blue;\n  }\n\n  .share-mode-options-roster {\n    display: flex;\n    gap: 1rem;\n\n    // Make both button areas the same width & height\n    >* {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: stretch;\n    }\n\n    .mode-button {\n      background-color: white;\n      color: $dk-blue;\n      border: 2px solid $dk-blue;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      font-size: 1rem;\n      border-radius: 8px;\n      transition: all 0.2s ease;\n      text-align: center;\n\n      &.active {\n        background-color: $dk-blue;\n        color: white;\n      }\n\n      &:hover {\n        background-color: $dk-blue;\n        color: white;\n        opacity: .9;\n      }\n\n      &:disabled {\n        background-color: $grey1;\n        border-color: $grey2;\n        color: $grey3;\n        cursor: not-allowed;\n      }\n    }\n\n    .mode-help-text {\n      font-size: 0.85rem;\n      color: $grey3;\n      margin-top: 0.5rem;\n      text-align: center;\n    }\n  }\n}\n\n.current-roster {\n  align-items: center;\n  display: flex;\n  margin-bottom: 0.75rem;\n\n  h5 {\n    color: $dk-blue;\n    margin-bottom: 0px;\n    margin-right: 32px;\n\n    span {\n      color: $pearl-blue;\n      font-weight: 700;\n    }\n  }\n}\n\n.no-margin {\n  margin-bottom: 0px;\n}\n\n.bottom-margin {\n  margin-bottom: 1rem;\n}\n\n.roster-select-section {\n  background-color: white;\n  border-radius: 5px;\n  margin-top: 1rem;\n  padding: 1.25rem;\n\n  .select-label-ic {\n    gap: 8px;\n    margin-bottom: 16px;\n\n    .ic-select {\n      @include borderRadius(5px);\n      border: 1px solid $grey3;\n      color: $grey4a;\n      padding: 3px;\n      margin-top: 12px;\n      min-width: 230px;\n    }\n  }\n}\n\n.delta-section {\n  margin-bottom: 1rem;\n\n  .delta-border {\n    border: 2px solid $important;\n  }\n\n  .delta-text {\n    margin-bottom: 24px;\n  }\n}\n\n.epr-roster-manage-section {\n  border-radius: 10px;\n\n  .bold-number {\n    font-weight: 700;\n    margin-left: 4px;\n  }\n}\n\n.accordion-button {\n  background-color: white !important;\n}\n\n.accordion-button:focus {\n  box-shadow: none;\n  border: 3px solid $pearl-blue-hover !important;\n}\n\n.delta-button-container {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 6px;\n  width: 100%;\n\n  .select-all-check-btn {\n    @include borderRadius(5px);\n    @include shadow();\n    align-items: center;\n    background-color: white;\n    border: 1px solid $pearl-blue;\n    color: $pearl-blue;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    width: 150px;\n    padding: 4px 8px;\n\n    input {\n      margin-right: 12px;\n      transform: scale(1.2)\n    }\n\n    &:hover {\n      transform: scale(1.035);\n    }\n  }\n}\n\n.delta-student-grid {\n  border-radius: 3px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  padding: 16px;\n\n  .delta-student-card {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);\n  }\n}\n\n\n\n/* Responsive Grid */\n@media (max-width: 839px) {\n  .delta-student-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 840px) and (max-width: 1499px) {\n  .delta-student-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1500px) {\n  .delta-student-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
